<div class="main-controls tab-control">
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control btn-sm dropdown-toggle row-control" id="button-basic" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
            <small>{{ "control_tab" | translate }}</small>
        </button>
        <ul
            *dropdownMenu
            id="dropdown-basic"
            class="dropdown-menu tab-dropdown-menu"
            role="menu"
            aria-labelledby="button-basic"
        >
            <li role="menuitem">
                <a class="dropdown-item" (click)="selectAction()">
                    <span class="sp-icon icon-pencil"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li><hr /></li>
            <li role="menuitem" [tooltip]="disableRemoveEvent ? disableRemoveEventTooltip : ''" placement="bottom">
                <a class="dropdown-item" [class.disabled]="disableRemoveEvent" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
